import { HistoricalDrawRow } from '@willow/types-iso';

import { makeValidator } from '../../shared/makeValidator';

export const validateHistoricalDraws = makeValidator({
  FieldParser: HistoricalDrawRow,
});
